<div *ngIf="selectedNode">

    <div>
        <span *ngIf="this.selectedNode.data.model.length==0">There are no Bulk Update Messages</span>
    </div>

    <div *ngIf="this.loading" style="padding-top: 300px;">
        <app-loading />
    </div>

    <div *ngIf="this.selectedNode.data.model.length>0" class="scroll-container"
        style="overflow-y: auto;height:calc(100vh - 235px)">

        <div style="margin-top: 10px;">
            <span>
                <b>
                    {{ this.getCurrentPath() }}
                </b>
            </span>
        </div>
        <div style="margin-top: 10px;">

            <table class="table table-striped table-hover table-sm table-max-width">
                <thead style="position: sticky;top: 0;">
                    <tr>
                        <th style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap"></th>
                        <th *ngFor="let column of selectedNode.getHeaders(); let i = index" (click)="sortBy(i)"
                            style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap"><a>{{
                                column }}
                                {{sortIcon(i)}}</a></th>
                    </tr>
                </thead>
                <tbody>
                    <tr style='cursor:pointer' *ngFor="let item of this.selectedNode.data.model">
                        <td style="white-space: nowrap;"><input type="checkbox" *ngIf="isAFile(item)"
                                [checked]="item.checked" (change)="select(item)" /></td>
                        <td style="width:auto;white-space: nowrap;" (click)="onItemFinderClick(item)"
                            *ngFor="let key of this.selectedNode.getKeys()">
                            <ng-container *ngIf="item[key] === 'back_arrow'; else showValue">
                                <i class="pi pi-arrow-left" title="Go back to previous level"></i>
                            </ng-container>
                            <ng-template #showValue>
                                <span class="underline" *ngIf="key==='num'">{{ item[key] }}</span>
                                <span class="underline" *ngIf="key==='fileName'">{{ item[key] }}</span>
                                <span class="underline" *ngIf="key==='count'">{{ item[key] }}</span>
                                <span class="underline" *ngIf="key==='date'">{{ this.formatDate(item[key]) }}</span>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>